import { DOCUMENT_LABELS } from "./common";

export const TOOLPANE_TTITLE = {
  DOC_COMPONENTS: "doc-components",
  NOTES: "notes",
  COLLABORATORS: "collaborators",
  CATALOG: "catalog",
  DOCUMENT_DETAILS: "document-details",
  DYNAMIC_FIELDS: "dynamic-fields",
  ACTIVITY: "activity",
  GOOGLE_CATALOG: "google-catalog",
  ATTACHMENTS: "attachments",
  QUICK_REVIEW: "quick-review",
};

/**
 * * Do not change the order inside the array, coz in UI
 * * they have to be displayed in same order.
 */
export const TOOLPANE_OPTIONS = {
  DOCUMENT: [
    {
      title: "doc-components",
      ico: "puzzle-piece",
      toolTipLabel: `${DOCUMENT_LABELS["component-label"]}`,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
    {
      title: "quick-review",
      ico: "microscope",
      toolTipLabel: "Metalens",
    },
  ],
  DEAL_TABLE: [
    {
      title: "catalog",
      ico: "clipboard-list-check",
      toolTipLabel: "Catalog",
      hideOnViewMode: true,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  GOOGLE_SHEET: [
    {
      title: "google-catalog",
      ico: "clipboard-list-check",
      toolTipLabel: "Google Sheet",
      hideOnViewMode: true,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  QUOTE_TABLE: [
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  TEMPLATE: [
    {
      title: "doc-components",
      ico: "puzzle-piece",
      toolTipLabel: `${DOCUMENT_LABELS["component-label"]}`,
    },
    {
      title: "dynamic-fields",
      ico: "brackets",
      toolTipLabel: `${DOCUMENT_LABELS["dynamic-label"]} Fields`,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/constants/toolpane.js